import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class HistoriqueService {

  constructor(private http: HttpClient, private tokenService : TokenService) { }

  /**
   * Récupère l'historique des actions entre deux dates
   * @param options 
   */
  getHistorique(options : Object) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/historique?options=" + (JSON.stringify(options));
    return this.http.get(request, {headers: httpHeaders});
  }

  /**
   * Récupère l'historique des actions d'un utilisateur entre deux dates
   */
  getHistoriqueByUser(options : Object) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/historique/by-user?options=" + (JSON.stringify(options));
    return this.http.get(request, {headers : httpHeaders});
  }

  /**
   * Récupère l'état des contenus d'une modération à une étape précise de l'historique
   */
  getContenusSpecificState (historique : number) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/historique/contenus/" + historique ;
    return this.http.get(request, {headers : httpHeaders});
  }


  getLastTraitement(idModeration:number, forCq:number=0) {
    let httpHeaders = this.tokenService.loadToken();
    let request = '/api/historique/last-historique?moderation=' + idModeration + '&cq=' + forCq;
    return this.http.get(request, {headers : httpHeaders});
  }

  getLastValidation(idModeration:number) {
    let httpHeaders = this.tokenService.loadToken();
    let request = '/api/historique/last-validation?moderation=' + idModeration;
    return this.http.get(request, {headers : httpHeaders});
  }
}
